import { H1 } from 'foundations-components/transitional/components/H1';
import { Paragraph } from 'foundations-components/transitional/components/Paragraph';
import { View } from 'foundations-components/transitional/components/View';
import { theme, useMediaQuery } from 'academy-common-lib/utils/Styling';
import ErrorBoundary from '../../../components/ErrorBoundary';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Header = props => {
  return /*#__PURE__*/_jsx(View, Object.assign({
    backgroundColor: "fill-surface-recessed",
    color: "text-core-default"
  }, props));
};
const PublicPageHeader = ({
  badgeText,
  heading,
  description,
  rightContent,
  children,
  paddingBlockEnd = '1000'
}) => {
  const {
    isDesktop
  } = useMediaQuery('desktop');
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    children: /*#__PURE__*/_jsx(Header, {
      children: /*#__PURE__*/_jsx(View, {
        backgroundColor: "fill-transparent-default",
        color: "text-core-default",
        paddingBlock: "1000",
        paddingBlockEnd: paddingBlockEnd,
        paddingInline: "400",
        textAlign: "center",
        children: /*#__PURE__*/_jsxs(View, {
          marginBlock: "0",
          marginInline: "auto",
          maxInlineSize: theme.sizes.GRID_BREAKPOINT_MEDIUM,
          position: "relative",
          children: [badgeText && /*#__PURE__*/_jsx(Tag, {
            marginBlockEnd: "600",
            children: badgeText
          }), heading && /*#__PURE__*/_jsx(H1, {
            children: heading
          }), description && /*#__PURE__*/_jsx(Paragraph, {
            typography: "body-200",
            children: description
          }), children, rightContent && /*#__PURE__*/_jsx(View, {
            inlineSize: "fit-content",
            insetBlockEnd: "0",
            insetInlineEnd: "-220px",
            marginBlock: "0",
            marginInline: "auto",
            maxInlineSize: "160px",
            position: isDesktop ? 'absolute' : 'static',
            children: rightContent
          })]
        })
      })
    })
  });
};
export default PublicPageHeader;